import { render } from "./contador_ingles.vue?vue&type=template&id=3b75054c&scoped=true"
import script from "./contador_ingles.vue?vue&type=script&lang=js"
export * from "./contador_ingles.vue?vue&type=script&lang=js"

import "./contador_ingles.vue?vue&type=style&index=0&id=3b75054c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b75054c"]])

export default __exports__